export default function () {
  return [
    {
      path: '/home',
      name: 'Home',
      component: () => import(/* webpackChunkName: 'home' */ '@views/home/home'),
      meta: {
        needLogin: false
        // title: 'home'
      }
    },
    // {
    //   path: '/publish',
    //   name: 'Publish',
    //   component: () => import(/* webpackChunkName: 'publish' */ '@views/home/publish'),
    //   meta: {
    //     needLogin: false,
    //     title: 'publish'
    //   }
    // },
    {
      path: '/shorVideoSearch',
      name: 'ShorVideoSearch',
      component: () => import(/* webpackChunkName: 'shorVideoSearch' */ '@views/shorVideoSearch'),
      meta: {
        needLogin: false,
        title: 'ShorVideoSearch'
      }
    },
    {
      path: '/myQrcode',
      name: 'MyQrcode',
      component: () => import(/* webpackChunkName: 'myQrcode' */ '@views/home/myQrCode'),
      meta: {
        needLogin: false,
        title: 'MyQrcode'
      }
    }
  ];
};
